<template>

    <div>

        <v-autocomplete
            :loading="is_loading_data"
            loading-text="圖卡有點多，您等一下🙂"
            auto-select-first
            chips
            clearable
            v-model.trim="main_choosed_items_string"
            :items="handleMainChoosedItems"
            label="主要行銷圖卡設定檔"
            v-bind:parent-choosed="local_main_choosed_items"
            :search-input.sync="searchMain"
            @click:append="test"
        ></v-autocomplete>

        <v-container
            class="px-0 mb-0 mt-0 mr-20"
            row
        >
            <!-- <v-card-title>
                主要行銷圖卡活動區間
                <span style="color: red; font-size: 12px; margin-left: 10px;">
                    * 擇一
                </span>
            </v-card-title> -->

            <!-- <v-radio-group v-model="activityState" row class="mr-20 ml-5">
                <v-radio
                    label="活動預熱"
                    value="warm_up_setting"
                    :color="$vuetify.theme.themes['dark']['primary']"
                ></v-radio>

                <v-radio
                    label="活動進行"
                    value="activity_card_setting"
                    :color="$vuetify.theme.themes['dark']['primary']"
                ></v-radio>

                <v-radio
                    label="活動結束"
                    value="end_up_setting"
                    :color="$vuetify.theme.themes['dark']['primary']"
                ></v-radio>
            </v-radio-group> -->

        </v-container>
        
        <v-autocomplete
            :loading="is_loading_data"
            loading-text="圖卡有點多，您等一下🙂"
            auto-select-first
            chips
            clearable
            deletable-chips
            multiple
            label="想被覆蓋的行銷圖卡設定檔"
            v-model.trim="secondary_choosed_items_string"
            :items="handleMainChoosedItems"
            @blur="getBatchEditDatas(secondary_choosed_items_string)"
            show-select
            :search-input.sync="searchSecondary"
        >
            
            
        </v-autocomplete>
        
        <v-container
            class="px-0 mb-0 mr-20"
            row
        >
            <!-- <v-card-title>
                想被覆蓋的行銷圖卡活動區間
                <span style="color: red; font-size: 12px; margin-left: 10px;">
                    * 可複選
                </span>
            </v-card-title>
            <v-checkbox
                v-model="check_select_all_timeline"
                :label="`全選`"
                @change="onChangeTimeLine()"
                class="mr-20 ml-5"
                :color="$vuetify.theme.themes['dark']['primary']"
            ></v-checkbox>

            <v-checkbox
                v-model="check_warm_up"
                :label="`活動預熱`"
                class="mr-20 ml-5"
                :color="$vuetify.theme.themes['dark']['primary']"
            ></v-checkbox>

            <v-checkbox
                v-model="check_activity"
                :label="`活動進行`"
                class="mr-20 ml-5"
                :color="$vuetify.theme.themes['dark']['primary']"
            ></v-checkbox>

            <v-checkbox
                v-model="check_end_up"
                :label="`活動結束`"
                class="mr-20 ml-5"
                :color="$vuetify.theme.themes['dark']['primary']"
            ></v-checkbox> -->

        </v-container>
        
        <v-container
            class="px-0 mb-20 mr-20 mt-0"
            row
        >
            <v-card-title>
                行銷圖卡區塊
                <span style="color: red; font-size: 12px; margin-left: 10px;">
                    * 可複選
                </span>
            </v-card-title>
            <v-checkbox
                v-model="check_select_all"
                :label="`全選`"
                @change="onChange()"
                class="mr-20 ml-5"
                color="primary"
            ></v-checkbox>

            <v-checkbox
                v-model="check_img"
                :label="`圖片`"
                class="mr-20 ml-5"
                color="primary"
            ></v-checkbox>

            <v-checkbox
                v-model="check_text"
                :label="`內文`"
                class="mr-20 ml-5"
                color="primary"
            ></v-checkbox>

            <v-checkbox
                v-model="check_title"
                :label="`標題`"
                class="mr-20 ml-5"
                color="primary"
            ></v-checkbox>

            <v-checkbox
                v-model="check_footer_text"
                :label="`行銷文字`"
                class="mr-20 ml-5"
                color="primary"
            ></v-checkbox>

            <v-checkbox
                v-model="check_timer"
                :label="`倒數計時器`"
                class="mr-20 ml-5"
                color="primary"
            ></v-checkbox>

            <v-checkbox
                v-model="check_mobile_mini_text"
                :label="`手機縮小圖卡文字`"
                class="mr-20 ml-5"
                color="primary"
            ></v-checkbox>

            <v-checkbox
                v-model="check_desktop_mini_text"
                :label="`桌機縮小圖卡文字`"
                class="mr-20 ml-5"
                color="primary"
            ></v-checkbox>

            <!-- <v-checkbox
                v-model="repeat_day"
                :label="`過期後指定輪迴天數`"
                class="mr-20 ml-5"
                :color="$vuetify.theme.themes['dark']['primary']"
            ></v-checkbox> -->

        </v-container>

        <v-btn 
            class="btn-wrapper border-dark-green txt-dark-green"
            @click="batchEdit()"
            color="primary"
            style="color: #fff"
        >
            <v-icon left>
                mdi-note-edit-outline
            </v-icon>				
            一鍵修改
        </v-btn>
        
    </div>

</template>

<script>
// import { debounce } from 'lodash'

import { mapGetters } from "vuex";

import {
    // apiCreateCard,
    apiUpdateCard,
    // apiCardGetBy
 } from "@/api/sales-card.js";


export default {
    name: "BatchEdit",
    components: {
        
    },
    data() {
        return {
			is_loading_data: false,
			main_choosed_items_string: "",
			secondary_choosed_items_string: "",
			local_main_choosed_items: this.mainChoosedItems,
            secondary_choosed_items: [],
            check_select_all: false,
            check_img: false,
            check_text: false,
            check_title:false,
            check_footer_text: false,
            check_timer: false, 
            check_mobile_mini_text: false,
            check_desktop_mini_text : false,
            repeat_day: false,
            main_choosed_items: [],
            searchMain: null,
            searchSecondary: null,
            resp: this.marketingCardSetting, 
            resp_utc_date: null,
            secondary_setting_card: [],
            secondary_setting_card_id: [],
            secondary_setting_card_to_arr: [],
            secondary_setting_card_id_to_arr: [],
            secondary_setting_card_id_to_arr_info_obj: [],
            secondary_setting_card_id_to_arr_set: [],
            main_setting_card: [],


            check_select_all_timeline: false,
            check_warm_up: false,
            check_activity: true,
            check_end_up: false,

            activityState: "activity_card_setting"
        }
    },
    mounted() {
        console.log("yo BatchEdit");
    },
    created() {
        console.log(this.marketingCardSetting);
        // this.marketingCardSetting.unshift({
        //     "setting_name": "全選"
        // })
    },
    methods: {
        test() {
            console.log("1");
        },
        handleSearch(value) {
            this.searchMain = value
        },
        getBatchEditDatas(secondary_choosed_items_string) {
            console.log(this.marketingCardSetting);
            let that = this
            let secondary_choosed_items_id = []
            console.log(secondary_choosed_items_string); 
            console.log(that.secondary_setting_card_id_to_arr);

            if (secondary_choosed_items_string.length !== that.secondary_setting_card_id_to_arr.length) {

                for (let i = 0; i < that.marketingCardSetting.length; i++) {

                    for (let j = 0; j < secondary_choosed_items_string.length; j++) {

                        if (secondary_choosed_items_string[j].split("圖卡名稱: ")[1] === that.marketingCardSetting[i]["setting_name"]) {
                            
                            secondary_choosed_items_id.push(that.marketingCardSetting[i]["id"])
                        
                        }

                    }
                }

                console.log(secondary_choosed_items_id);

                let del_ele_id_arrs = that.secondary_setting_card_id_to_arr.filter((element) => {
                    return secondary_choosed_items_id.indexOf(element) === -1
                })
                console.log(del_ele_id_arrs);

                for (let i = 0; i < del_ele_id_arrs.length; i++) {
                    that.secondary_setting_card_id_to_arr.splice(that.secondary_setting_card_id_to_arr.indexOf(del_ele_id_arrs[i]),1)
                }
                console.log("所有選到的設定檔id :",that.secondary_setting_card_id_to_arr);

                that.getAllSettingDatas()

            }
            
        },
        checkInputIsNotNull : function() {

            let that = this
            let isOK = true

            // 檢查欄位是不是都有勾選
            if (that.main_setting_card.length == 0) {
                alert('主要圖卡設定檔尚未選擇～')
                return false
            } else if (that.activityState === "") {
                alert('主要圖卡活動區間未選擇～')
                return false
            } else if (that.secondary_setting_card_to_arr.length == 0) {
                alert('欲覆蓋的圖卡設定檔未選擇～')
                return false
            } else if (that.secondary_setting_card_id_to_arr.length == 0) {
                return false
            } else if ( !that.check_activity && !that.check_end_up && !that.check_warm_up) {
                alert('尚未勾選要覆蓋的圖卡活動區間～')
                return false
            } else if ( !that.check_img && !that.check_text && !that.check_timer && !that.check_title && !that.check_footer_text && !that.check_desktop_mini_text && !that.check_mobile_mini_text && !that.repeat_day ) {
                alert('尚未勾選要覆蓋的圖卡區塊～')
                return false
            } else {
                return isOK
            }
            
        },
        getAllSettingDatas: function () {

            this.resp_utc_date = JSON.parse(JSON.stringify(this.marketingCardSetting))
            console.log(this.resp_utc_date);
            let that = this

            while (that.secondary_setting_card_to_arr.length) {

                that.secondary_setting_card_to_arr.pop()
            }

            if (that.secondary_setting_card_to_arr.length == 0) {

                for (let i = 0; i < that.resp_utc_date.length; i++) {

                    for (let j = 0; j < that.secondary_setting_card_id_to_arr.length; j++) {
                        
                        if (that.resp_utc_date[i]["id"] === that.secondary_setting_card_id_to_arr[j]) {
                            
                            that.secondary_setting_card_to_arr.push(that.resp_utc_date[i])
                        
                        }

                    }
                }
            }
            
            console.log(that.secondary_setting_card_to_arr)

            return that.secondary_setting_card_to_arr
        },
        onChangeTimeLine() {
            if (this.check_select_all_timeline) {
                this.check_warm_up = true
                this.check_activity = true
                this.check_end_up = true
            } else {
                this.check_warm_up = false
                this.check_activity = false
                this.check_end_up = false
            }
        },
        onChange() {
            if (this.check_select_all) {
                this.check_img = true
                this.check_text = true
                this.check_title = true
                this.check_footer_text = true 
                this.check_timer = true
                this.check_mobile_mini_text = true
                this.check_desktop_mini_text = true
                this.repeat_day = true
            } else {
                this.check_img = false
                this.check_text = false
                this.check_title = false
                this.check_footer_text = false 
                this.check_timer = false
                this.check_mobile_mini_text = false
                this.check_desktop_mini_text = false
                this.repeat_day = false
            }
        },
        batchEdit: function () {

            let that = this
            let isDone = this.checkInputIsNotNull()
            let confirm_dialog

            if (isDone) {

                confirm_dialog = confirm('是否確定要將以下設定檔覆蓋？')

                if (confirm_dialog) {
                    console.log(this.main_setting_card[0]);
                    console.log(JSON.parse(this.main_setting_card[0]['add_column'])[this.activityState]);
                    // let main_setting_card = JSON.parse(this.main_setting_card[0]['add_column'])[this.activityState]
                    // main_setting_card['id'] = this.main_setting_card[0]['id']
                    that.getSettingCardHtml(JSON.parse(this.main_setting_card[0]['add_column'])[this.activityState])
                } else {

                    console.log(that.secondary_choosed_items_string); 
                    console.log(that.secondary_setting_card_id_to_arr);
                    console.log("不覆蓋！");
                }

            }

        },
        getSettingCardHtml: async function (res) {
            console.log('314行', res);
            console.log("424行",this.secondary_setting_card_to_arr);
            console.log(this.check_activity);
            console.log(this.check_warm_up);
            console.log(this.check_end_up);
            let secondary_time_line = []
            this.check_activity ? secondary_time_line.push('activity_card_setting') : this.check_activity
            this.check_warm_up ? secondary_time_line.push('warm_up_setting') : this.check_activity
            this.check_end_up ? secondary_time_line.push('end_up_setting') : this.check_activity
            console.log(secondary_time_line);
            
            
            //console.log(res.repeat_day);
            let that = this 
            let origin_card_html
            let mini_card_html
            let desktop_mini_card_html
            let setting_card_id
            let main_repeat_day
            

            origin_card_html = JSON.parse(JSON.stringify(res['card_content']))
            mini_card_html = JSON.parse(JSON.stringify(res['card_hint']))
            desktop_mini_card_html = JSON.parse(JSON.stringify(res['desktop_card_hint']))
            main_repeat_day = res['repeat_day']
            console.log(main_repeat_day);
            

            let main_start_at = new Date(res["start_at"]).toISOString()
            let main_end_at = new Date(res["end_at"]).toISOString()
            

            let secondary_dom
            let secondary_img_ele
            let secondary_text_ele
            let secondary_title
            let secondary_footer_text
            let secondary_dom_mobile_mini
            let secondary_mobile_mini_text_ele
            let secondary_dom_desktop_mini
            let secondary_desktop_mini_text_ele
            
            let main_dom
            let main_img_ele
            let main_text_ele
            let main_title
            let main_footer_text
            let main_dom_mobile_mini
            let main_mobile_mini_text_ele 
            let main_dom_desktop_mini
            let main_desktop_mini_text_ele
            
            console.log("465",that.secondary_setting_card_to_arr);

            

            that.secondary_setting_card_to_arr.forEach(function (item) {

                secondary_time_line.forEach( timeline_key => {
                    console.log(item);
                    console.log(timeline_key);
                    console.log(JSON.parse(item['add_column']));
                    let field = JSON.parse(item['add_column'])[timeline_key]
                    console.log(item);
                    setting_card_id = item['id']
                    field["edit_at"] = "2021-10-12T03:20:55.190Z"
                    
                    
                    // 要被覆蓋的 
                    secondary_dom = that.createDomByHtmlString(field["card_content"])
                    
                    secondary_img_ele = secondary_dom.getElementsByClassName('card-img')[0].src.toString()
                    
                    secondary_text_ele = secondary_dom.querySelector('section.card-text-content')
                    secondary_title = secondary_dom.getElementsByClassName('card-header')[0]
                    
                    secondary_footer_text = secondary_dom.getElementsByClassName('card-footer')[0]
                    
                    secondary_dom_mobile_mini = that.createDomByHtmlString(field["card_hint"])
                    secondary_mobile_mini_text_ele = secondary_dom_mobile_mini.getElementsByClassName('mini-card-text-container')[0]

                    secondary_dom_desktop_mini = that.createDomByHtmlString(field["desktop_card_hint"])					
                    secondary_desktop_mini_text_ele = secondary_dom_desktop_mini.getElementsByClassName('mini-card-text-container')[0]


                    // 覆蓋別人的 (主檔)
                    main_dom = that.createDomByHtmlString(origin_card_html)
                    main_img_ele = main_dom.getElementsByClassName('card-img')[0].src.toString()
                    main_text_ele = main_dom.querySelector('section.card-text-content')
                    main_title = main_dom.getElementsByClassName('card-header')[0]
                    main_footer_text = main_dom.getElementsByClassName('card-footer')[0]

                    main_dom_mobile_mini = that.createDomByHtmlString(mini_card_html)
                    main_mobile_mini_text_ele = main_dom_mobile_mini.getElementsByClassName('mini-card-text-container')[0]
                    
                    main_dom_desktop_mini = that.createDomByHtmlString(desktop_mini_card_html)
                    main_desktop_mini_text_ele = main_dom_desktop_mini.getElementsByClassName('mini-card-text-container')[0]


                    // do{

                        if (!that.check_img) {
                            console.log("1");
                            origin_card_html = origin_card_html.replace(main_img_ele, secondary_img_ele)
                        }
                        if (!that.check_text) {
                            console.log("2");
                            origin_card_html = origin_card_html.replace(main_text_ele.outerHTML,secondary_text_ele.outerHTML)
                        }
                        if (that.check_timer) {
                            console.log("3");
                            field["end_at"] = main_end_at
                            field["start_at"] = main_start_at
                        }
                        if (!that.check_footer_text) {
                            console.log("4");
                            origin_card_html = origin_card_html.replace(main_footer_text.outerHTML,secondary_footer_text.outerHTML)
                        }
                        if (!that.check_title) {
                            console.log("5");
                            origin_card_html = origin_card_html.replace(main_title.outerHTML,secondary_title.outerHTML)
                        }
                        if (!that.check_mobile_mini_text) {
                            console.log("6");
                            mini_card_html = mini_card_html.replace(main_mobile_mini_text_ele.outerHTML,secondary_mobile_mini_text_ele.outerHTML)
                        }
                        if (!that.check_desktop_mini_text) {
                            console.log("7");
                            desktop_mini_card_html = desktop_mini_card_html.replace(main_desktop_mini_text_ele.outerHTML,secondary_desktop_mini_text_ele.outerHTML)
                        }
                        if (that.repeat_day) {
                            field["repeat_day"] = main_repeat_day
                            console.log("8");
                        }

                    // } while(0)
                    
                    
                    field['card_hint'] = JSON.parse(JSON.stringify(mini_card_html))
                    field['desktop_card_hint'] = JSON.parse(JSON.stringify(desktop_mini_card_html))
                    field["card_content"] = JSON.parse(JSON.stringify(origin_card_html))
                    
                    delete field['id']

                    console.log(field);
                    console.log(JSON.parse(item['add_column'])[timeline_key])

                    let item_add_column = JSON.parse(item['add_column'])
                    console.log('timeline_key',timeline_key)
                    item_add_column[timeline_key] = JSON.parse(JSON.stringify(field))
                    item['add_column'] = JSON.stringify(item_add_column)

                    
                })
                
                // console.log(item);
                
                // item["edit_at"] = "2021-10-12T03:20:55.190Z"
                // // item["end_at"] = new Date(item["end_at"]).toISOString()
                // // item["start_at"] = new Date(item["start_at"]).toISOString()
                
                
                // // 要被覆蓋的 
                // secondary_dom = that.createDomByHtmlString(item["card_content"])
                
                // secondary_img_ele = secondary_dom.getElementsByClassName('card-img')[0].src.toString()
                
                // secondary_text_ele = secondary_dom.querySelector('section.card-text-content')
                // secondary_title = secondary_dom.getElementsByClassName('card-header')[0]
                
                // secondary_footer_text = secondary_dom.getElementsByClassName('card-footer')[0]
                
                // secondary_dom_mobile_mini = that.createDomByHtmlString(item["card_hint"])
                // secondary_mobile_mini_text_ele = secondary_dom_mobile_mini.getElementsByClassName('mini-card-text-container')[0]

                // secondary_dom_desktop_mini = that.createDomByHtmlString(item["desktop_card_hint"])					
                // secondary_desktop_mini_text_ele = secondary_dom_desktop_mini.getElementsByClassName('mini-card-text-container')[0]


                // // 覆蓋別人的 (主檔)
                // main_dom = that.createDomByHtmlString(origin_card_html)
                // main_img_ele = main_dom.getElementsByClassName('card-img')[0].src.toString()
                // main_text_ele = main_dom.querySelector('section.card-text-content')
                // main_title = main_dom.getElementsByClassName('card-header')[0]
                // main_footer_text = main_dom.getElementsByClassName('card-footer')[0]

                // main_dom_mobile_mini = that.createDomByHtmlString(mini_card_html)
                // main_mobile_mini_text_ele = main_dom_mobile_mini.getElementsByClassName('mini-card-text-container')[0]
                
                // main_dom_desktop_mini = that.createDomByHtmlString(desktop_mini_card_html)
                // main_desktop_mini_text_ele = main_dom_desktop_mini.getElementsByClassName('mini-card-text-container')[0]


                // // do{

                //     if (!that.check_img) {
                //         console.log("1");
                //         origin_card_html = origin_card_html.replace(main_img_ele,secondary_img_ele)
                //     }
                //     if (!that.check_text) {
                //         console.log("2");
                //         origin_card_html = origin_card_html.replace(main_text_ele.outerHTML,secondary_text_ele.outerHTML)
                //     }
                //     if (that.check_timer) {
                //         console.log("3");
                //         item["end_at"] = main_end_at
                //         item["start_at"] = main_start_at
                //     }
                //     if (!that.check_footer_text) {
                //         console.log("4");
                //         origin_card_html = origin_card_html.replace(main_footer_text.outerHTML,secondary_footer_text.outerHTML)
                //     }
                //     if (!that.check_title) {
                //         console.log("5");
                //         origin_card_html = origin_card_html.replace(main_title.outerHTML,secondary_title.outerHTML)
                //     }
                //     if (!that.check_mobile_mini_text) {
                //         console.log("6");
                //         mini_card_html = mini_card_html.replace(main_mobile_mini_text_ele.outerHTML,secondary_mobile_mini_text_ele.outerHTML)
                //     }
                //     if (!that.check_desktop_mini_text) {
                //         console.log("7");
                //         desktop_mini_card_html = desktop_mini_card_html.replace(main_desktop_mini_text_ele.outerHTML,secondary_desktop_mini_text_ele.outerHTML)
                //     }
                //     if (that.repeat_day) {
                //         item["repeat_day"] = main_repeat_day
                //         console.log("8");
                //     }

                // // } while(0)
                
                
                // item['card_hint'] = JSON.parse(JSON.stringify(mini_card_html))
                // item['desktop_card_hint'] = JSON.parse(JSON.stringify(desktop_mini_card_html))
                // item["card_content"] = JSON.parse(JSON.stringify(origin_card_html))
                
                // delete item['id']
                
                
                that.putSettingData(item, setting_card_id)
                
            })
                
            
        },
        putSettingData: function (item, setting_card_id) {
            console.log(item);
            let that = this
            apiUpdateCard(item, this.selectedContainer.org_id, setting_card_id).then(function(resp) {
            // apiUpdateSpecificSettingData(item, setting_card_id).then(function() {
                // console.log(response);
                // console.log("成功！");

                that.secondary_setting_card_to_arr.splice(that.secondary_setting_card_to_arr.indexOf(item),1)
                if (that.secondary_setting_card_to_arr.length == 0) {
                    console.log(resp);
                    // window.location.reload()
                    that.main_choosed_items_string = ''
                    that.secondary_choosed_items_string = ''
                    that.check_select_all = false
                    that.check_img = false
                    that.check_text = false
                    that.check_title = false
                    that.check_footer_text = false 
                    that.check_timer = false
                    that.check_mobile_mini_text = false
                    that.check_desktop_mini_text = false
                    that.repeat_day = false
                    that.$emit('update')
                }
            })
            .catch((error) => {
                console.log(error);
                alert('apiUpdateSpecificSettingData Api 異常～')
            })
        },
        /**
         * 2021-10-15 created by Watson
         *
         * 說明: 用來重現圖卡用的程式，可以把html_string變成dom
         *
        */
        createDomByHtmlString: function(html_string) {
            var div = document.createElement('div');
            div.innerHTML = html_string.trim();
            return div.firstChild;
        }
    },
    computed: {
        ...mapGetters(["selectedContainer","selectedAdmin","selectedOrg","selectedMarketingCardContainer","oldSettingData","marketingCardSetting"]),
        handleMainChoosedItems() {
            console.log(this.marketingCardSetting);
            return this.marketingCardSetting.map( item => {
                
                // 如果是空字串，代表不是縣市圖卡，然後如果都是undefined，代表是我故意在created時第一項插入空物件，要給他一個項目叫全選
                return item.tags === "" 
                    ? `圖卡名稱: ${item.setting_name}`
                    : item.tags === undefined && item.setting_name === undefined 
                        ? `全選`
                        : `縣市名稱: ${item.tags} 圖卡名稱: ${item.setting_name}`
            })
        },
        // debouncedSearch: {
        //     get() {
        //         return this.searchMain
        //     },
        //     set(value) {
        //         this.debouncedInput(value)
        //     }
        // },
    },
    watch: {
        marketingCardSetting: {
            handler(newValue) {
                console.log('marketingCardSetting :', newValue);
                
            },
            immediate: true
        },
        main_choosed_items_string: function (newVal) {
				let that = this
				console.log('您選擇的主要圖卡名稱：',newVal);
				
				if (newVal !== null) {
					// console.log("0");
					console.log(newVal.split('圖卡名稱: ')[1]);
					// console.log(newVal.split('縣市名稱 : ')[1].split(';圖卡名稱 :')[0]);
					for (let i = 0; i < that.marketingCardSetting.length; i++) {

						if (that.marketingCardSetting[i]['tags'] === "" && that.marketingCardSetting[i]['setting_name'] === newVal.split('圖卡名稱: ')[1]) {
							// 選到圖卡名稱沒有重複且是一般圖卡
							
							that.main_setting_card.push(that.marketingCardSetting[i])
							
						} else if (that.marketingCardSetting[i]['tags'] !== "" && that.marketingCardSetting[i]['setting_name'] === newVal.split('圖卡名稱: ')[1]) {
							
							that.main_setting_card.push(that.marketingCardSetting[i])
							// console.log(that.main_setting_card);
							if (that.main_setting_card.length > 1) {

								if (newVal.indexOf("縣市名稱") === -1) {
									// console.log("1");
									for (let i = 0; i < that.main_setting_card.length; i++) {

										if (that.main_setting_card[i]['tags'] !== "") {
											// console.log("2");
											that.main_setting_card.splice(that.main_setting_card.indexOf(that.main_setting_card[i]),1)
										}
									}

								} else {
									// console.log("3");
									for (let i = 0; i < that.main_setting_card.length; i++) {

										if (that.main_setting_card[i]['tags'] === "") {

											// console.log("4");
											that.main_setting_card.splice(that.main_setting_card.indexOf(that.main_setting_card[i]),1)

										}else if (that.main_setting_card[i]['tags'] !== "" && that.main_setting_card[i]['tags'] !== newVal.split('縣市名稱: ')[1].split(' 圖卡名稱 :')[0]){
											// console.log("5");
											that.main_setting_card.splice(that.main_setting_card.indexOf(that.main_setting_card[i]),1)
										}

										
									}

								}

							}
						}
						
					}

					
					
					console.log(that.main_setting_card);

					// that.deleteChoosedEle()
				} else {

					while (that.main_setting_card.length) {
						that.main_setting_card.pop();
					}
					
					// console.log(that.main_setting_card);
				}
				
			},
        secondary_choosed_items_string: function (newVal) {
            console.log(newVal);
            console.log(Array.isArray(newVal));
            // let result  = newVal.find( value => value === '全選')
            // if (result) {
            //     this.secondary_choosed_items_string = [...this.marketingCardSetting]
            //     return
            // } else {
            //     this.secondary_choosed_items_string = []
            // }
            let that = this

            if (newVal.length > 0) {

                for (let i = 0; i < that.marketingCardSetting.length; i++) {
                    
                    for (let j = 0; j < newVal.length; j++) {
                        
                        if (newVal[j].indexOf("縣市名稱") === -1 && that.marketingCardSetting[i]['tags'] === "" && that.marketingCardSetting[i]['setting_name'] === newVal[j].split("圖卡名稱: ")[1]) {
                            
                            that.secondary_setting_card.push(that.marketingCardSetting[i])
                            
                        }else if (newVal[j].indexOf("縣市名稱") !== -1 && that.marketingCardSetting[i]['tags'] !== "" && that.marketingCardSetting[i]['setting_name'] === newVal[j].split("圖卡名稱: ")[1] && that.marketingCardSetting[i]['tags'] === newVal[j].split("縣市名稱: ")[1].split(" 圖卡名稱")[0]) {
                            
                            that.secondary_setting_card.push(that.marketingCardSetting[i])
                        
                        }
                    }
                }

                
                console.log(that.secondary_setting_card);
                

                for (let i = 0; i < that.secondary_setting_card.length; i++) {
                    that.secondary_setting_card_id.push(that.secondary_setting_card[i]['id'])
                }
                
                console.log("尚未用過Set過濾的所有設定檔id :",that.secondary_setting_card_id);
                let secondary_setting_card_id_to_set = new Set(that.secondary_setting_card_id);
                that.secondary_setting_card_id_to_arr = JSON.parse(JSON.stringify([...secondary_setting_card_id_to_set]))
                console.log('欲覆蓋的所有圖卡設定檔id :',that.secondary_setting_card_id_to_arr);
                
                that.getAllSettingDatas()
            
            } else {

                console.log("刪除陣列內容～");

                while (that.secondary_setting_card.length) {
                    that.secondary_setting_card.pop();
                }
                console.log(that.secondary_setting_card);

                while (that.secondary_setting_card_id.length) {
                    that.secondary_setting_card_id.pop();
                }
                console.log(that.secondary_setting_card_id);

                while (that.secondary_setting_card_to_arr.length) {
                    that.secondary_setting_card_to_arr.pop()
                }
                console.log(that.secondary_setting_card_to_arr);

                while (that.secondary_setting_card_id_to_arr.length) {
                    that.secondary_setting_card_id_to_arr.pop()
                }
                console.log(that.secondary_setting_card_id_to_arr);

            }
        }
    }
}
</script>

<style scoped>
    .mb-20{
        margin-bottom: 20px;
    }
    .mr-20{
        margin-right: 20px;
    }
    .ml-5{
        margin-left: 5px;
    }
</style>